import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))


export async function fetchStoresAPI(){
    return await axiosClient.get('/api/v1/admin/store/all/');
}

export async function fetchStoreDetailsAPI(storeId) {
    return await axiosClient.get(`/api/v1/admin/store/${storeId}`)
}

export async function addStoreAPI(data) {
    return await axiosClient.post(`/api/v1/admin/store`, data);
}

export async function updateStoreAPI(data,storeId) {
    return await axiosClient.put(`/api/v1/admin/store/${storeId}`, data);
}

export async function updateStoreBranchAPI(data, branchId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/admin/store/settings/branch/${branchId}`, data)
}

export async function deleteStoreAPI(storeId) {
    return await axiosClient.delete(`/api/v1/admin/store/${storeId}`);
}


